import { CUSTOM_CONTENT_WORD_COUNT_LIMIT } from './constants';

export const ASSIGNMENT_SUBMISSION_TYPES = ['documents', 'videos', 'slides', 'spreadsheets'];
export const EVIDENCE_INSTRUCTION_CHARACTER_LIMIT = 100000;

const EXTENSIONS = {
    documents: ['doc', 'docx', 'pdf', 'txt', 'rtf', 'odt', 'html', 'htm', 'jpg', 'jpeg', 'png'],
    videos: ['mp4', 'mpg', 'mpeg', 'mov', 'm4v', 'webm', 'avi', 'wmv', 'mkv'],
    slides: ['ppt', 'pptx', 'pdf', 'odp'],
    spreadsheets: ['xls', 'xlsx', 'csv', 'ods'],
};

const knownTypes = (values) => ASSIGNMENT_SUBMISSION_TYPES.filter((type) => values.includes(type));

export const inferSubmissionTypes = (apiData = {}) => {
    const source = apiData || {};
    const accepted = source.allowed_extensions ?? source.allowed_file_extensions ?? source.allowedExtensions;
    const extensions = (
        Array.isArray(accepted) ? accepted : typeof accepted === 'string' ? accepted.split(/[,\s]+/) : []
    )
        .filter((extension) => typeof extension === 'string' && extension.trim())
        .map((extension) => extension.trim().replace(/^\./, '').toLowerCase());
    const methods = Array.isArray(source.submission_types) ? source.submission_types : [];
    if (
        !extensions.length &&
        (!methods.length || methods.includes('online_upload') || methods.includes('online_url'))
    ) {
        return [...ASSIGNMENT_SUBMISSION_TYPES];
    }
    return ASSIGNMENT_SUBMISSION_TYPES.filter(
        (type) =>
            extensions.some((extension) => EXTENSIONS[type].includes(extension)) ||
            (type === 'documents' && methods.includes('online_text_entry')) ||
            (type === 'videos' && methods.includes('media_recording'))
    );
};

export const getAssignmentSubmissionTypes = (form) => {
    const saved = form?.gradingSettings?.submission_types ?? form?.ai_grading_settings?.submission_types;
    return Array.isArray(saved) ? knownTypes(saved) : inferSubmissionTypes(form?.api_data);
};

export const toggleAssignmentSubmissionType = (form, type) => {
    if (!ASSIGNMENT_SUBMISSION_TYPES.includes(type)) return form;
    const selected = getAssignmentSubmissionTypes(form);
    return {
        ...form,
        gradingSettings: {
            ...form.gradingSettings,
            submission_types: knownTypes(
                selected.includes(type) ? selected.filter((item) => item !== type) : [...selected, type]
            ),
        },
    };
};

export const updateEvidencePreferences = (form, type, preferences) => {
    if (!ASSIGNMENT_SUBMISSION_TYPES.includes(type)) return form;
    return {
        ...form,
        gradingSettings: {
            ...form.gradingSettings,
            submission_types: getAssignmentSubmissionTypes(form),
            evidence_preferences: {
                ...form.gradingSettings?.evidence_preferences,
                [type]: { ...form.gradingSettings?.evidence_preferences?.[type], ...preferences },
            },
        },
    };
};

export const hasEvidenceSuggestion = (value, suggestion) => value.split(/\r?\n/).includes(suggestion);

export const toggleEvidenceSuggestion = (value, suggestion) => {
    if (hasEvidenceSuggestion(value, suggestion)) {
        return value
            .split(/\r?\n/)
            .filter((line) => line !== suggestion)
            .join('\n');
    }
    return `${value}${value && !value.endsWith('\n') ? '\n' : ''}${suggestion}`;
};

export const getEvidenceWordCount = (value) => value.trim().split(/\s+/).filter(Boolean).length;

export const isEvidenceInstructionTooLong = (value) =>
    value.length > EVIDENCE_INSTRUCTION_CHARACTER_LIMIT ||
    getEvidenceWordCount(value) > CUSTOM_CONTENT_WORD_COUNT_LIMIT;
